import { get } from 'lodash';
import { FormStrucItem } from '../../../../lib/types/types';

// import schemas
import { ANTRAG_VERBUNDPARTNER } from '../../../../lib/constants/componentsPath';
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const mapAssoziiertePartner = (formStruc: FormStrucItem[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Assoziierte_Partner.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Assoziierte_Partner.path.length),
				};
			}),
		};
	});
	return result;
};

export const mapVerbundPartner = (formStruc: FormStrucItem[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path: pathWithoutIndex.slice(0, P.Verbundpartner.path.length) + `.${index}` + pathWithoutIndex.slice(P.Verbundpartner.path.length),
				};
			}),
		};
	});
	return result;
};
export const mapVerbundPartnerAnsprechpartner = (formStruc: FormStrucItem[], partnerIndex: number, ansprechpartnerIndex: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>)
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.path.length) +
							`.${ansprechpartnerIndex}` +
							pathWithoutIndex.slice(P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin.path.length),
					};
				})
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Verbundpartner.path.length) +
							`.${partnerIndex}` +
							pathWithoutIndex.slice(P.Verbundpartner.path.length),
					};
				}),
		};
	});
	return result;
};
export const isPartnerSelectFieldDisabled = (application: any, partnerIndex: number, readOnly: boolean) => {
	if (readOnly) return true;
	const vParterSelectedValue = get(application, `${P.Verbundpartner.path}.${partnerIndex}.${ANTRAG_VERBUNDPARTNER.Partner}`);

	let vPartnerID: number;
	if (typeof vParterSelectedValue === 'object') vPartnerID = vParterSelectedValue.id;
	else vPartnerID = vParterSelectedValue;

	const allKP = get(application, P.Foerderantrag_Kostenpositions.path, []);
	const checkIfKPForVPartnerExist = allKP.find((ele: any) => get(ele, `${KP_P.Unternehmen.path}.id`) === vPartnerID);

	if (checkIfKPForVPartnerExist) return true;
	else return false;
};
